'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _errors = require('./errors');

var DEFAULTS = {
    apiRoot: '',
    mutateResponse: null,
    headers: null,
    cookies: null,

    prepareError: _errors.ValidationError.defaultPrepareError,
    parseErrors: _errors.ValidationError.defaultParseErrors,

    statusSuccess: [200, 201, 204],
    statusValidationError: [400],

    defaultHeaders: {
        Accept: 'application/json'
    }
};

exports.default = DEFAULTS;


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/dist/constants.js
// module id = 300
// module chunks = 0